module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('div', {
    staticClass: "notedetail"
  }, [_c('div', {
    staticClass: "article-title",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.optionsa[this.Detail.item].label) + "\n      ")]), _vm._v(" "), _c('article', {
    domProps: {
      "innerHTML": _vm._s(this.Detail.contentStr)
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head"
  }, [_c('a', {
    staticClass: "back tl",
    attrs: {
      "href": "javascript:history.back(-1)"
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('a', {
    staticClass: "font-size: 18px;text-align: center;",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('small', {
    staticClass: "font_18 co_f"
  }, [_vm._v("违法行为查处")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-304b5a49","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/note/RewardPunish.vue
// module id = 476
// module chunks = 1